import moment from 'moment';
import SegmentUtils from 'utils/segment';
import getParkingType from '../utils/parking-type';
import getUserLocation from '../utils/user-location';

export default function trackCheckoutStarted({
    isMonthly,
    facility: {parking_spot_id, title, airport, operator_id},
    user: {email},
    eventId,
    citySlug,
    starts,
    ends,
    isAirport,
    price,
    currency,
}) {
    const now = moment();
    const isEvent = Boolean(eventId);
    const reservationStart = moment(starts);
    const reservationEnd = moment(ends);
    const parkingType = getParkingType({isMonthly, isAirport, isEvent});
    const properties = {
        ...(isAirport && {
            airport_code: airport.details.code,
        }),
        city: citySlug,
        currency,
        email,
        ...(isEvent && {event_id: eventId}),
        operator_id,
        parking_spot_id,
        parking_spot_name: title,
        parking_type: parkingType,
        products: [
            {
                category: parkingType,
                name: title,
                price,
                product_id: String(parking_spot_id),
                quantity: 1,
            },
        ],
        rental_end_time_utc: reservationEnd.toISOString(),
        rental_lead_time: reservationStart.diff(now, 'minutes'),
        rental_length: reservationEnd.diff(reservationStart, 'minutes'),
        rental_start_time_utc: reservationStart.toISOString(),
        ...getUserLocation(),
    };

    SegmentUtils.track({
        event: 'Checkout Started',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 1,
                },
            },
        },
    });
}
